import { Brand } from "types/model.types";
import { authApi } from "./";

export const getBrands = async () => {
  const response = await authApi.get("brand/get");
  return response ?? [];
};

export const UpdateBrand = async (b: Brand) => {
  const url = `brand/${
    b.id === undefined || b.id === "" || b.id === 0 ? "add" : "update"
  }`;
  const response = await authApi.post(url, {
    nm: b.name,
    id: b.id,
  });

  return response;
};

export const deleteBrandById = async (id: string | number) => {
  const response = await authApi.post("brand/delete", {
    id,
  });

  return response;
};
